(() => {
  'use strict';
  if (window.PXRestockReady) return;
  window.PXRestockReady = true;
  const readyForms = () => document.querySelectorAll('[data-px-restock]:not([data-ready])').forEach(form => {
    form.dataset.ready = 'true';
    const submit = form.querySelector('[type="submit"]');
    form.dataset.buttonLabel = submit.innerHTML;
    submit.disabled = false;
  });
  const start = () => {
    readyForms();
    new MutationObserver(readyForms).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('click', event => {
    const another = event.target.closest('[data-px-restock-another]');
    if (!another) return;
    const form = another.closest('[data-px-restock]');
    delete form.dataset.saved;
    form.querySelectorAll('input,select,button').forEach(control => { control.disabled = false; });
    form.querySelector('[type="submit"]').innerHTML = form.dataset.buttonLabel;
    form.querySelector('[role="status"]').textContent = '';
    another.hidden = true;
    form.elements.restock_variant.value = '';
    const url = new URL(location.href); url.searchParams.delete('variant'); history.replaceState({}, '', url);
    form.elements.restock_variant.focus();
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-px-restock] select[name="restock_variant"]');
    if (!select) return;
    const url = new URL(location.href);
    if (select.value) url.searchParams.set('variant', select.value);
    else url.searchParams.delete('variant');
    history.replaceState({}, '', url);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-px-restock]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const size = form.elements.restock_variant;
    const email = form.elements.restock_email.value.trim();
    const variantId = size.value;
    const selectedSize = size.selectedOptions[0]?.textContent || '';
    const status = form.querySelector('[role="status"]');
    const button = form.querySelector('[type="submit"]');
    if (!/^\d+$/.test(variantId) || !Array.from(size.options).some(option => option.value === variantId)) return;
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    const controls = Array.from(form.querySelectorAll('input,select,button'));
    controls.forEach(control => { control.disabled = true; });
    const originalButton = button.innerHTML;
    button.textContent = 'Saving your request…';
    status.textContent = '';
    delete status.dataset.error;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(form.dataset.companyId)}`, {
        method: 'POST', signal: controller.signal,
        headers: { accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify({ data: {
          type: 'back-in-stock-subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email } } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } } }
        } })
      });
      if (response.status !== 202) throw new Error(response.status === 429 ? 'Please wait a moment and try again.' : 'We couldn’t save your request. Please try again or email care@perseveranx.com.');
      button.textContent = 'Request received';
      status.textContent = `Your restock request has been received for Fusion · Mixed Sea · ${selectedSize}. We’ll email you when this size is available.`;
      form.dataset.saved = 'true';
      const another = form.querySelector('[data-px-restock-another]');
      another.hidden = false;
      another.disabled = false;
    } catch (error) {
      status.dataset.error = 'true';
      status.textContent = error.name === 'AbortError' || error instanceof TypeError ? 'We couldn’t confirm your request. Please check your connection and try again.' : error.message;
      controls.forEach(control => { control.disabled = false; });
      button.innerHTML = originalButton;
    } finally {
      clearTimeout(timeout);
      form.dataset.busy = 'false';
      form.removeAttribute('aria-busy');
    }
  });
})();
